import { createVNode as e, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ContractFilledStandard.js";
import l from "../components/PfIcon.js";
const t = (r, a) => {
  const o = {
    ...r,
    ...a.attrs
  };
  return e(l, n(o, {
    icon: d
  }), null);
};
t.displayName = "ContractFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
